import { PageEvent } from '@angular/material/paginator';
import { BehaviorSubject } from 'rxjs';
import { IOrganisation } from 'src/app/interfaces/organisation';
import { IResponseBody } from 'src/app/interfaces/response-body';
import { ApiDataSource } from 'src/app/services/api-data-source.service';
import { OrganisationAdminApiService } from 'src/modules/role/organisation-admin/services/organisation-admin-api-service';

export class OrganisationDataSource extends ApiDataSource {
  protected Data: BehaviorSubject<IOrganisation[]> = new BehaviorSubject([]);

  constructor(
    protected role: string,
    protected Api?: OrganisationAdminApiService,
    private readonly userId?: number
  ) {
    super();
  }

  protected loadData(PageEvent?: PageEvent) {
    return this.Api.getOrgs(this.userId, this.filter.value, PageEvent, this.role);
  }

  public save(org: IOrganisation[] = []) {
    return this.Api.save(this.role, org);
  }

  public updateAccountCode(org) {
    return this.Api.updateAccountCode('admin', org);
  }

  protected setData(ResponseBody: IResponseBody) {
    this.Data.next(ResponseBody.data);
  }
  public getById(id: number) {
    return this.Api.read(id, this.role);
  }
}
